// src/apollo/client.ts - Simplified version that should work
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_URL || 'http://localhost:3000/graphql',
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          tests: {
            keyArgs: false,
            merge(_existing: any[], incoming: any[]) {
              return incoming;
            }
          }
        }
      },
      TestDetails: {
        keyFields: ['TestId']
      }
    }
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
    mutate: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

// import { ApolloClient, InMemoryCache, createHttpLink, split } from '@apollo/client';
// import { setContext } from '@apollo/client/link/context';
// import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
// import { createClient } from 'graphql-ws';
// import { getMainDefinition } from '@apollo/client/utilities';

// const httpLink = createHttpLink({
//   uri: process.env.REACT_APP_GRAPHQL_URL || 'http://localhost:3000/graphql',
// });

// const authLink = setContext((_, { headers }) => {
//   const token = localStorage.getItem('token');
//   return {
//     headers: {
//       ...headers,
//       authorization: token ? `Bearer ${token}` : "",
//     }
//   }
// });

// const wsLink = new GraphQLWsLink(createClient({
//   url: process.env.REACT_APP_WS_URL || 'ws://localhost:3000/graphql',
//   connectionParams: {
//     authToken: localStorage.getItem('token'),
//   },
// }));

// const splitLink = split(
//   ({ query }) => {
//     const definition = getMainDefinition(query);
//     return (
//       definition.kind === 'OperationDefinition' &&
//       definition.operation === 'subscription'
//     );
//   },
//   wsLink,
//   authLink.concat(httpLink),
// );

// export const client = new ApolloClient({
//   link: splitLink,
//   cache: new InMemoryCache({
//     typePolicies: {
//       Query: {
//         fields: {
//           patients: {
//             merge(existing, incoming) {
//               return incoming;
//             }
//           }
//         }
//       }
//     }
//   }),
//   defaultOptions: {
//     watchQuery: {
//       fetchPolicy: 'network-only',
//     },
//   },
// });